'use client';
import clsx from 'clsx';
import FullWrapper from 'core/FullWrapper';
import ScrollAnimation from 'core/ScrollAnimation';
import React, { SetStateAction, useState } from 'react';
import CertificatesDescription from 'shared/sections/Certificates/CertificatesDescription';
import CommonTitle from 'shared/sections/CommonTitle';
import SiteCardFilter from 'shared/sections/SiteCardsFilter/SiteCardFilter';

import cn from './style.module.sass';

type DescriptionType = {
    description: string;
};

type CompanyType = {
    img: string;
    name: string;
    link: string;
    direction?: string;
    category?: string;
};

type CertificatesProps = {
    listCompanyCard: CompanyType[];
    listDescription?: DescriptionType;
    isLessThanEight?: boolean;
    isSolution?: boolean;
    isSeo?: boolean;
};
export default function SiteCardsFilter({
    listCompanyCard,
    listDescription,
    isLessThanEight,
    isSolution,
    isSeo,
}: CertificatesProps) {
    const [selectedFilter, setSelectedFilter] = useState('solutions');
    const filters = [
        { label: 'SEO по цели', value: 'seo' },
        { label: 'Отраслевые решения', value: 'solutions' },
    ];
    const handleFilterChange = (filter: SetStateAction<string>) => {
        setSelectedFilter(filter);
    };

    const filteredCards = listCompanyCard.filter(card =>
        selectedFilter ? card.category === selectedFilter : true
    );

    return (
        <ScrollAnimation>
            <FullWrapper smallPaddings={true} isMargin={false} className={cn['site-cards']}>
                <CommonTitle className={cn['site-cards__title']}>
                    {isSeo ? 'Услуги SEO продвижения' : 'Продвигаем сайты в различных нишах'}
                </CommonTitle>

                {listDescription?.description && (
                    <CertificatesDescription description={listDescription.description} />
                )}
                <div className={cn['site-cards__content']}>
                    <div className={cn['site-cards__buttons']}>
                        {filters.map(({ label, value }) => (
                            <button
                                key={value}
                                className={clsx(cn['site-cards__button'], {
                                    [cn['site-cards__active']!]: selectedFilter === value,
                                })}
                                onClick={() => handleFilterChange(value)}
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                    <div className={cn['site-cards__wrapper']}>
                        <div className={cn['site-cards__grid']}>
                            {filteredCards.map(({ img, name, link, direction }) => (
                                <SiteCardFilter
                                    key={name}
                                    isSolution={isSolution}
                                    name={name}
                                    img={img}
                                    link={link}
                                    direction={direction}
                                    isLessThanEight={isLessThanEight}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
}
